import React, { useEffect, useRef, useState } from "react";
import "./GuestButton.scss";

// Separate GuestSelector component
const GuestSelector = ({ guestsNo, setGuestsNo, peopleCapacity }) => {
  const handleAdults = (type) => {
    setGuestsNo((prev) => {
      let newCount = prev.adults;

      if (type === "plus") {
        if (newCount < peopleCapacity) {
          newCount++;
        }
      } else {
        if (newCount > 0) {
          newCount--;
        }
      }

      return { ...prev, adults: newCount };
    });
  };

  const handleChildren = (type) => {
    setGuestsNo((prev) => {
      let newCount = prev.children;

      if (type === "plus") {
        newCount++;
      } else {
        if (newCount > 0) {
          newCount--;
        }
      }

      return { ...prev, children: newCount };
    });
  };

  return (
    <div className="guest-dropdown">
      <div className="guest-wrap">
        <div className="ltl-guest">
          <span className="guest-category">Adults</span>
          <span className="guest-description">(Ages 16 or above)</span>
        </div>
        <div className="rtl-guest">
          <button
            className="minus-btn"
            onClick={() => handleAdults("minus")}
          >
            -
          </button>
          <span className="btn-value">{guestsNo.adults}</span>
          <button
            className="plus-btn"
            onClick={() => handleAdults("plus")}
            disabled={guestsNo.adults >= peopleCapacity}
          >
            +
          </button>
        </div>
      </div>
      <div className="guest-wrap">
        <div className="ltl-guest">
          <span className="guest-category">Children</span>
          <span className="guest-description">(Ages 0-12 or above)</span>
        </div>
        <div className="rtl-guest">
          <button
            className="minus-btn"
            onClick={() => handleChildren("minus")}
          >
            -
          </button>
          <span className="btn-value">{guestsNo.children}</span>
          <button
            className="plus-btn"
            onClick={() => handleChildren("plus")}
          >
            +
          </button>
        </div>
      </div>
      <div className="guest-wrap">
        <h4>{`${peopleCapacity} guests maximum`}</h4>
      </div>
    </div>
  );
};

const GuestButton = ({
  guestsNo,
  setGuestsNo,
  setShowGuestsInput,
  showGuestsInput,
  peopleCapacity
}) => {
  const [totalCount, setTotalCount] = useState(0);
  const dropdownRef = useRef(null);

  useEffect(() => {
    setTotalCount(guestsNo.adults + guestsNo.children);
  }, [guestsNo]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowGuestsInput(false);
      }
    };

    if (showGuestsInput) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showGuestsInput]);

  return (
    <div className="guest-section guest-btn" ref={dropdownRef}>
      <div className="guest-btn-inner">
        <span>{totalCount ? totalCount : "0"} Guests</span>
        <div
          className="guest-number d-flex justify-content-between align-items-center"
          onClick={() => setShowGuestsInput((prev) => !prev)}
        >
          Add Guests
          <i
            className={showGuestsInput ? "icon-dropdown active" : "icon-dropdown"}
          ></i>
        </div>
      </div>
      {showGuestsInput && (
        <GuestSelector
          guestsNo={guestsNo}
          setGuestsNo={setGuestsNo}
          peopleCapacity={peopleCapacity}
        />
      )}
    </div>
  );
};

export default GuestButton;
